import { ContentReducerCreator } from '../types';

const clearUploadedVideosReducer = (create: ContentReducerCreator) => {
  return create.reducer((state) => {
    state.uploadedVideos = null;
  });
};

export default clearUploadedVideosReducer;
